import React, { useState, useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import SettingsContainer from '../../../SettingsContainer';

import useSettingsForm from '../../../../../forms/lender/settings';
import LenderService from '../../../../../services/LenderService';
import { useUiContext } from '../../../../../context/UiContext';
import AccountService from '../../../../../services/AccountService';
import { useServicerStore } from '../../../../../store';

export default function Settings({ lender, isVisible, lenderId }) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { showToast } = useUiContext();

  const userRole = useServicerStore((state) => state.userRole);
  const isLender = userRole === 'lender';

  const { data: accounts } = useQuery({
    queryKey: ['accountsSettings'],
    queryFn: AccountService.getAccounts,
    enabled: !!lender,
  });

  const saveSettings = async (formValues) => {
    try {
      setIsSubmitting(true);

      const valuesWithMortgageesPositions = {
        ...formValues,
        default_insurance_mortgagees:
          formValues.default_insurance_mortgagees.map((mortgagee, index) => ({
            ...mortgagee,
            position: index + 1,
          })),
      };

      await LenderService.updateLender({
        formValues: valuesWithMortgageesPositions,
        lenderId,
      });
      showToast({
        text: 'Settings saved',
        type: 'success',
      });
    } catch (error) {
      showToast({
        text: 'Something went wrong',
        type: 'error',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const waterfall = useMemo(() => {
    let defaultPaymentWaterfall = [];
    const defaultPaymentWaterFallFromAccounts = accounts?.map((account) => ({
      account_id: account.id,
      sequence: account.default_sequence,
    }));

    if (lender?.default_payment_waterfall.length > 0) {
      defaultPaymentWaterfall = lender.default_payment_waterfall;
    } else if (accounts?.length > 0) {
      defaultPaymentWaterfall = defaultPaymentWaterFallFromAccounts;
    }

    return defaultPaymentWaterfall;
  }, [accounts, lender?.default_payment_waterfall]);

  const serverData = useMemo(
    () => ({
      ...lender,
      default_payment_waterfall: waterfall,
      default_insurance_mortgagees:
        lender?.default_insurance_mortgagees &&
        lender.default_insurance_mortgagees.length
          ? lender.default_insurance_mortgagees
          : [{ id: Math.random().toString(), mortgagee_type: '' }],
    }),
    [waterfall, lender]
  );

  const settingsForm = useSettingsForm(saveSettings, serverData, isLender);

  // console.log('settingsForm', settingsForm.formik.errors);

  return (
    <SettingsContainer
      form={settingsForm}
      isVisible={isVisible}
      isSubmitting={isSubmitting}
    />
  );
}
